import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { ethers } from "ethers";
import { useDexProvider } from "../../../Hooks/DexProvider";
import {
  SwapQuoteComponentProps,
  SwapQuoteComponentRef,
} from "../../../Components/interface";
import { TOKENS } from "../../../Components/config";

// Uniswap V3 Quoter contract address on Ethereum Mainnet
const QUOTER_ADDRESS = "0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6";

// ABI for Uniswap V3 Quoter's quoteExactInputSingle
const QUOTER_ABI = [
  "function quoteExactInputSingle(address tokenIn, address tokenOut, uint24 fee, uint256 amountIn, uint160 sqrtPriceLimitX96) external view returns (uint256 amountOut)",
];

export const UniswapQuoteComponent = forwardRef<
  SwapQuoteComponentRef,
  SwapQuoteComponentProps
>(({ tokenIn, tokenOut, amountIn, fee, OnComplete }, ref) => {
  const {
    provider,
    error: errorProvider,
    isLoading: providerLoading,
  } = useDexProvider();
  const [quote, setQuote] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const fetchQuote = async () => {
    if (!TOKENS[tokenIn] || !TOKENS[tokenOut]) {
      setError("Invalid token name.");
      return;
    }
    console.log(TOKENS[tokenIn], TOKENS[tokenOut]);
    try {
      const quoterContract = new ethers.Contract(
        QUOTER_ADDRESS,
        QUOTER_ABI,
        provider,
      );

      const amountInWei = ethers.parseUnits(
        amountIn.toString(),
        TOKENS[tokenIn].decimals,
      );
      const result = await quoterContract.quoteExactInputSingle.staticCall(
        TOKENS[tokenIn].address,
        TOKENS[tokenOut].address,
        fee,
        amountInWei,
        0,
      );

      const quoteInReadable = parseFloat(
        ethers.formatUnits(result, TOKENS[tokenOut].decimals),
      ).toFixed(4);
      setQuote(quoteInReadable);
      setError(null);
      OnComplete();
    } catch (err: any) {
      setError(`Failed to fetch quote: ${err.message}`);
      setQuote(null);
    }
  };

  useImperativeHandle(ref, () => ({
    fetchQuote,
  }));

  return (
    <>
      {quote && (
        <div className="flex justify-between items-center">
          <div className="creator">
            <div className="wrapper">
              <img src={"/images/exchange/uniswap.png"} alt={"Uniswap"} />
            </div>
            <p>
              <ins>Uniswap</ins>
            </p>
          </div>
          <div className="flex flex-column">
            <span>{quote}</span>
            <span className="text-right text-[#6f6f6f] text-[12px]">
              fee: {fee / 10000}%
            </span>
          </div>
        </div>
      )}
      {error && (
        <div className="mt-4 text-red-500">
          Failed to load data from the uniswap server.
        </div>
      )}
    </>
  );
});
